import $ from 'jquery';

export class MainMenu {
    public static init(): void {
        const mainMenus = document.querySelectorAll('.main-menu');
        for (const mainMenu of Array.from(mainMenus)) {
            const hovers = $(mainMenu).find('> .dropdown-hover');

            for (const hover of Array.from(hovers)) {
                const dropdown = $(hover).find('> .dropdown-nav-menu');

                if (dropdown.length === 0) continue;

                hover.addEventListener('click', (e) => {
                    if (dropdown.css('display') === 'flex') {
                        dropdown.css('display', 'none');
                    } else {
                        dropdown.css('display', 'flex');
                    }
                });
            }
        }
    }
}
